import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateRfqAmazonInput,
    ModelSortDirection,
    RfqAmazon,
    UpdateRfqAmazonInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class RfqAmazonService {
    private amplifyClient = generateClient();

    constructor() {}

    async getRfqAmazon(id: string): Promise<RfqAmazon | null> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getRfqAmazon,
                    variables: { id }
                })
            ).data.getRfqAmazon;
            return data ? (data as RfqAmazon) : null;
        } catch (error) {
            console.error('Error finding RfqAmazon:', error);
            return null;
        }
    }

    async listAllRfqsAmazonByCreated(
        estatus: string,
        sortDirection: ModelSortDirection = ModelSortDirection.DESC,
        pageLimit: number = 20
    ): Promise<RfqAmazon[]> {
        const rfqs: RfqAmazon[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listRfqsAmazonByCreated,
                        variables: {
                            estatus,
                            limit: pageLimit,
                            nextToken,
                            sortDirection
                        }
                    })
                ).data.listRfqsAmazonByCreated;

                if (response?.items) {
                    rfqs.push(...(response.items as RfqAmazon[]));
                }
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);

            return rfqs;
        } catch (error) {
            console.error('Error listing RfqAmazon:', error);
            return [];
        }
    }

    async listRfqAmazons(): Promise<RfqAmazon[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listRfqAmazons
                })
            ).data.listRfqAmazons.items;
            if (data) return data as RfqAmazon[];
        } catch (error) {
            console.error('Error finding RfqAmazon:', error);
            return null;
        }
    }

    async listRfqsAmazonByCreated(estatus: string): Promise<RfqAmazon[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listRfqsAmazonByCreated,
                    variables: {
                        estatus
                    }
                })
            ).data.listRfqsAmazonByCreated.items;
            if (data) return data as RfqAmazon[];
        } catch (error) {
            console.error('Error product:', error);
            return null;
        }
    }

    async listRfqsByAmazonByClient(estatus: string): Promise<RfqAmazon[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listRfqsByAmazonByClient,
                    variables: {
                        estatus
                    }
                })
            ).data.listRfqsByAmazonByClient.items;
            if (data) return data as RfqAmazon[];
        } catch (error) {
            console.error('Error finding RfqAmazon:', error);
            return null;
        }
    }

    async listRfqsAmazonByClientC(estatus: string): Promise<RfqAmazon[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listRfqsAmazonByClientC,
                    variables: {
                        estatus
                    }
                })
            ).data.listRfqsAmazonByClientC.items;
            if (data) return data as RfqAmazon[];
        } catch (error) {
            console.error('Error finding RfqAmazon:', error);
            return null;
        }
    }

    async createRfqAmazon(input: CreateRfqAmazonInput): Promise<RfqAmazon> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createRfqAmazon,
                    variables: {
                        input
                    }
                })
            ).data.createRfqAmazon;
            if (date) return date as RfqAmazon;
        } catch (error) {
            console.error('Error creating RfqAmazon:', error);
            return null;
        }
    }

    async update(input: UpdateRfqAmazonInput): Promise<RfqAmazon> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateRfqAmazon,
                    variables: {
                        input
                    }
                })
            ).data.updateRfqAmazon;
            if (date) return date as RfqAmazon;
        } catch (error) {
            console.error('Error creating RfqAmazon:', error);
            return null;
        }
    }
}
